export class UiState {

    public importDialogVisible: boolean = false;
    public partnerDialogVisible: boolean = false;
    public exportUtpDialogVisible: boolean = false;

    public static empty = () => new UiState();
}